/* ============================================
   CROWN & TEXTURE — SHOPIFY THEME
   Main JavaScript
   ============================================ */

(function () {
  'use strict';

  /* ---- Cart Drawer ---- */
  const cartDrawer = document.getElementById('cart-drawer');

  window.openCartDrawer = function () {
    cartDrawer.classList.add('is-open');
    cartDrawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  };

  window.closeCartDrawer = function () {
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  if (cartDrawer) {
    cartDrawer.querySelector('.cart-drawer__overlay').addEventListener('click', closeCartDrawer);
    cartDrawer.querySelector('.cart-drawer__close').addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        updateCartTotal(cart.total_price);
        renderCartItems(cart);
      });
  }

  function renderCartItems(cart) {
    const body = document.getElementById('cart-drawer-body');
    const subtotal = document.getElementById('cart-drawer-subtotal');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div style="text-align:center;padding:48px 24px;">
          <p style="font-size:32px;margin-bottom:16px;">♛</p>
          <p style="color:var(--color-muted);font-size:15px;margin-bottom:24px;">Your cart is empty</p>
          <a href="/collections/all" class="btn btn--primary" onclick="closeCartDrawer()">Shop Now</a>
        </div>`;
      if (subtotal) subtotal.textContent = '$0.00';
      return;
    }

    const html = cart.items.map((item) => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <div class="cart-item__details">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.line_price)}</div>
          <div class="cart-item__qty">
            <button class="qty-btn" onclick="updateItem('${item.key}', ${item.quantity - 1})">−</button>
            <span class="qty-display">${item.quantity}</span>
            <button class="qty-btn" onclick="updateItem('${item.key}', ${item.quantity + 1})">+</button>
            <button onclick="updateItem('${item.key}', 0)" style="background:none;border:none;cursor:pointer;color:var(--color-muted);font-size:16px;margin-left:8px;" title="Remove">✕</button>
          </div>
        </div>
      </div>`).join('');

    body.innerHTML = html;
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  }

  window.updateItem = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        updateCartTotal(cart.total_price);
        renderCartItems(cart);
      });
  };

  /* ---- Add to Cart ---- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    const form = btn.closest('form[action="/cart/add"]') || btn.closest('[data-product-form]');
    const variantId = form
      ? (form.querySelector('[name="id"]') || {}).value
      : btn.dataset.variantId;

    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added!';
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1800);
        refreshCartDrawer();
        openCartDrawer();
      })
      .catch(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });

  /* ---- Cart count update ---- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ---- Cart total update ---- */
  function updateCartTotal(totalCents) {
    document.querySelectorAll('[data-cart-total]').forEach(el => {
      el.textContent = formatMoney(totalCents);
    });
  }

  /* ---- Format money ---- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---- Init cart count on page load ---- */
  function initCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        updateCartTotal(cart.total_price);
      });
  }

  /* ---- Accordions ---- */
  function initAccordions() {
    document.querySelectorAll('.accordion-trigger').forEach(trigger => {
      trigger.addEventListener('click', function () {
        const item = this.closest('.accordion-item');
        const isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ---- Newsletter ---- */
  function initNewsletter() {
    // Allow Shopify's native newsletter form to submit normally.
  }

  /* ---- Filter pills ---- */
  function initFilters() {
    document.querySelectorAll('.filter-pill').forEach(pill => {
      pill.addEventListener('click', function () {
        document.querySelectorAll('.filter-pill').forEach(p => p.classList.remove('is-active'));
        this.classList.add('is-active');
      });
    });
  }

  /* ---- Mobile menu ---- */
  function initMobileMenu() {
    const toggle = document.querySelector('.mobile-menu-toggle');
    const nav = document.querySelector('.mobile-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---- Search Modal ---- */
  window.openSearch = function () {
    const modal = document.querySelector('.search-modal');
    if (!modal) return;
    modal.classList.add('is-open');
    modal.querySelector('input').focus();
  };

  window.closeSearch = function () {
    document.querySelector('.search-modal')?.classList.remove('is-open');
  };

  /* ---- Scroll-based animations ---- */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.product-card, .collection-card, .testimonial-card, .feature').forEach(el => {
      observer.observe(el);
    });
  }

  /* ---- Sticky header shadow ---- */
  function initStickyHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---- Init on DOM ready ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initCartCount();
    initAccordions();
    initNewsletter();
    initFilters();
    initMobileMenu();
    initScrollAnimations();
    initStickyHeader();
  });

})();